import { Box } from '@mui/material';
import PolicyContentSection, {
  SectionTitle,
  SectionContent,
  SubsectionText,
} from '../../../shared/components/PolicyContentSection';
import { ExternalLink } from './styles';

const ContentSection = () => {
  return (
    <PolicyContentSection
      title="Scope of Practice and Legal Compliance"
      lastUpdated="Last updated: September 8th, 2026"
    >
      <Box sx={{ mb: 4 }}>
        <SectionContent>
          Nirva Interpersonal Hypnotherapy Clinics is a collective of practitioners holding a range
          of professional credentials. All practitioners are required to practice strictly within
          the scope of their individual education, training, licensure (if applicable), and
          credentials, and to comply with all applicable federal, state, county, and municipal laws
          and regulations.
        </SectionContent>
      </Box>

      <Box sx={{ mb: 4 }}>
        <SectionTitle>Non-Licensed Hypnotherapists</SectionTitle>
        <SectionContent>
          Hypnosis and hypnotherapy laws vary by jurisdiction, and all practitioners affiliated with
          Nirva are required to practice within the limits of their training, credentials, and the
          laws applicable both where the practitioner is located and where the client receives
          services. As a conservative operational standard, Nirva distinguishes non-therapeutic
          hypnosis from hypnosis used for therapeutic purposes and requires heightened legal and
          professional safeguards whenever services involve a medical, mental-health, dental, or
          other regulated condition. When therapeutic hypnosis is legally permissible for a
          non-licensed practitioner through collaboration with a licensed practitioner, Nirva
          requires the appropriate referral, supervision, direction, prescription or professional
          authorization, and assumption of responsibility required by the applicable jurisdiction.
          In Florida, this standard is particularly stringent: Florida Statute §485.004 provides
          that therapeutic hypnosis may be performed by a non-licensed qualified person only when
          acting under the “supervision, direction, prescription, and responsibility” of a
          practitioner of the healing arts. Accordingly, Nirva does not treat a written referral
          alone as sufficient authorization for therapeutic hypnosis when Florida law applies.
        </SectionContent>
      </Box>

      <Box sx={{ mb: 4 }}>
        <SectionTitle>Interstate and Cross-State Sessions</SectionTitle>
        <SectionContent>
          In the event of interstate or cross-state sessions—where the practitioner and client are
          located in different states—practitioners are required to adhere to the laws and
          regulations of the state with the most restrictive or stringent requirements.
        </SectionContent>
      </Box>

      <Box sx={{ mb: 4 }}>
        <SectionTitle>Practice Limitations</SectionTitle>
        <SectionContent>
          Non-licensed practitioners do not diagnose, treat, or claim to treat medical, dental, or
          mental health conditions, and provide services solely within the bounds of non-therapeutic
          hypnosis and the applicable laws of their respective jurisdictions.
        </SectionContent>
      </Box>

      <Box sx={{ mb: 4 }}>
        <SectionTitle>Additional Resources</SectionTitle>
        <SectionContent>
          For additional information regarding hypnosis laws by state, please visit:
        </SectionContent>
        <SubsectionText>
          <ExternalLink
            component="a"
            href="https://instituteofhypnotherapy.com/iaih-hypnosis-law/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://instituteofhypnotherapy.com/iaih-hypnosis-law/
          </ExternalLink>
        </SubsectionText>
      </Box>

      <Box sx={{ mb: 6 }}>
        <SectionTitle>Referrals</SectionTitle>
        <SectionContent>
          Nirva Interpersonal Hypnotherapy Clinics also refers clients to appropriately licensed
          practitioners when clinically or legally indicated.
        </SectionContent>
      </Box>
    </PolicyContentSection>
  );
};

export default ContentSection;
